import { render, staticRenderFns } from "./DbpyRL_Row.vue?vue&type=template&id=bfb04678"
import script from "./DbpyRL_Row.vue?vue&type=script&lang=js"
export * from "./DbpyRL_Row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports